import { coins } from '../mockedData'

const NETWORK_COINS = {
  TRON: ['USDT', 'TRX'],
  POLYGON: ['USDC', 'POL', 'USDT'],
  // ETHEREUM: ['ETH', 'USDC', 'USDT'],
  // SOLANA: ['SOL', 'USDC'],
}

export const getCoinsByNetwork = (network) => {
  const allowedCoins = NETWORK_COINS[network]

  if (!allowedCoins) {
    return coins
  }

  return coins.filter((coin) => allowedCoins.includes(coin.value))
}
